import type { FaireProductEntity } from "../../entity_types/product";

export const p_y4h3rscwz6: FaireProductEntity = {
  token: "p_y4h3rscwz6",
  type: "product",
  name: "Carved Gemstone Mushroom Pendant Mixed Lot 12 Pieces",
  brandToken: "b_q8ypma3xp2",
  brandName: "Superior Stones & Gifts INTL LLP",
  imageUrl: "https://cdn.faire.com/fastly/ca34d16d36e509889e4e0577a174a80c34c5fdd67a6166e1a19413f78ea8e766.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/955d0dd515b83f8bcaea85d1f2229f74d5daacea5cb42f99f4de0d1382bb6f4e.jpeg",
    "https://cdn.faire.com/fastly/69dce29003485fc22e33e3f6b41a354cdaf7b73bc6d183bbf4842ffbf44b5779.jpeg",
    "https://cdn.faire.com/fastly/4b282b172c03193ca6f6dae93594c3238f1c87d7dba0eed521c9e5820a581c49.jpeg"
  ],
  priceDollars: 22,
  description: "\nAdd a touch of whimsy to your jewelry collection with this lot of 12 carved gemstone mushroom pendants. Each piece features a nicely carved mushroom design, perfect for adding a playful and quirky touch to any outfit. These pendants are sure to be conversation starters and statement pieces.\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:04.038Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
